export enum EAccountTypes {
    cash = 0,
    tfsa = 1,
    rrsp = 2,
    credit = 3,
    saving = 4,
}

export const AccountTypes = [
    {value:EAccountTypes.cash, label:"CASH"},
    {value:EAccountTypes.tfsa, label:"TFSA"},
    {value:EAccountTypes.rrsp, label:"RRSP"},
    {value:EAccountTypes.credit, label:"CREDIT"},
    {value:EAccountTypes.saving, label:"SAVINGS"},
]

export interface IAccount {
    n:string;
    t:EAccountTypes;
    h?:boolean;
}